import React, { useState } from "react";
import { useAuth } from "../../auth/useAuth.js";
import { accountsApi } from "../../api/auctiongate.js";

const GROUPS = [
  { key: "copart", label: "Copart (US)" },
  { key: "copartCanada", label: "Copart Canada", apiKey: "copart_canada" },
  { key: "iaai", label: "IAAI (US)" },
  { key: "iaaiCanada", label: "IAAI Canada", apiKey: "iaai_canada" },
];

/**
 * Active account switcher — plugin calls reInitAccountCopart / reInitAccountIAAI.
 * In our proxy that's /api/accounts/switch.
 */
export default function AccountSwitcher() {
  const { user } = useAuth();
  const accounts = user?.accounts ?? {};
  const current = user?.currentAccountIds ?? {};
  const [busy, setBusy] = useState(null);
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState(null);

  const doSwitch = async (auctionKey, accId) => {
    setBusy(`${auctionKey}-${accId}`);
    setErr(null);
    setMsg(null);
    try {
      const r = await accountsApi.switch({ auction: auctionKey, accId });
      setMsg(r?.success ?? r?.message ?? "Switch request sent.");
    } catch (e) {
      setErr(e?.message || "Switch failed.");
    } finally {
      setBusy(null);
    }
  };

  return (
    <div className="card">
      <div className="card__title">
        Account switcher
        <span className="badge">/api/accounts/switch</span>
      </div>
      {err && <div className="login-error">{err}</div>}
      {msg && <div className="small" style={{ color: "var(--color-success)" }}>{String(msg)}</div>}
      <div className="grid grid-2">
        {GROUPS.map((g) => {
          const list = Array.isArray(accounts[g.key]) ? accounts[g.key] : [];
          const cur = current[g.key];
          const apiKey = g.apiKey || g.key;
          return (
            <div key={g.key} style={box}>
              <div style={{ fontWeight: 700, marginBottom: 8 }}>{g.label}</div>
              {list.length === 0 ? (
                <div className="small muted">No accounts.</div>
              ) : (
                list.map((acc, i) => {
                  const isCurrent = String(acc.id) === String(cur);
                  const label = acc.type === "master" ? "Master" : acc.type === "slave" ? "Secondary" : `#${i + 1}`;
                  return (
                    <button
                      key={acc.id ?? i}
                      className={`btn ${isCurrent ? "btn-accent" : "btn-ghost"}`}
                      disabled={isCurrent || !acc.id || busy === `${apiKey}-${acc.id}`}
                      onClick={() => doSwitch(apiKey, acc.id)}
                      style={{ width: "100%", marginBottom: 6, justifyContent: "flex-start" }}
                    >
                      {busy === `${apiKey}-${acc.id}` ? (
                        <span className="loader" />
                      ) : (
                        <>
                          {label} · #{acc.buyer_number ?? "—"} {isCurrent && "✓"}
                        </>
                      )}
                    </button>
                  );
                })
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

const box = {
  padding: 12,
  border: "1px solid var(--color-border)",
  borderRadius: 10,
  background: "var(--color-bg-card-elevated)",
};
